<template>
    <el-date-picker
        v-model="bindValue"
        :size="size"
        :type="type"
        align="right"
        :placeholder="placeholder"
        :style="{width: width}"
        :picker-options="option"
        range-separator=" ~ "
        :disabled="disabled"
        value-format="yyyy-MM-dd"
        @change="updateValue">
    </el-date-picker>
</template>
<script>
    /**
     * 基于element-ui的DatePicker封装，将需要参数配置封装，使用v-model直接绑定 
     * @author zjs
     * @time 2017-06-08
     */
    export default {
        name: 'LyDatePicker',
        props: {
            value: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '100%'
            },
            size: {
                type: String,
                default: 'small'
            },
            type: {
                type: String,
                default: 'daterange'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isToday: { // 是否默认有今日的时间
                type: Boolean,
                default: true
            },
            isDistinguish: { // 区分是否需要失去焦点关闭浮层
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                bindValue: '', // 时间组件绑定的值
                // 时间范围选择的设置
                daterangeOption: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近一个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近三个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }]
                },
                // 选择日的选项设置
                dateOption: {
                    shortcuts: [{
                        text: '今天',
                        onClick (picker) {
                            picker.$emit('pick', new Date());
                        }
                     }, {
                        text: '昨天',
                        onClick (picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '前天',
                        onClick (picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick (picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },
        computed: {
            option () {
                if (this.type === 'daterange') {
                    return this.daterangeOption
                } else {
                    return this.dateOption
                }
            },
            placeholder () {
                if (this.type === 'daterange') {
                    return '选择日期范围'
                } else {
                    return '选择日期'
                }
            }
        },
        created () {
            this.splitValue()
        },
        watch: {
            value (val) {
                this.splitValue()
            }
        },
        methods: {
            blurFn (picker) {
                if (this.type !== 'daterange' && this.isDistinguish) {
                    setTimeout(() => {
                        picker.handleClose()
                    }, 100)
                }
            },
            /**
             * 时间改变的事件
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            updateValue: function (value) {
                value = (value === null ? '' : value)
                if (Array.isArray(value)) {
                    value = value.join('~')
                }
                if (this.value !== value) {
                    this.$emit('input', value)
                }
            },
            splitValue () {
                let value = this.value === '0000-00-00 00:00:00' ? '' : this.value
                if (this.type === 'daterange') {
                    if (value.length > 0) {
                        let arr = value.split('~')
                        if (arr.length === 2) {
                            this.bindValue = arr
                        }
                    } else {
                        this.bindValue = ''
                    }
                } else {
                    if (value && value.length > 0) {
                        this.bindValue = value
                    } else if (this.isToday) {
                        this.bindValue = this.getNowFormatDate()
                        this.updateValue(this.bindValue)
                    }
                }
            },
            /**
             * 获得当前时间
             * @return {[type]} [description]
             */
            getNowFormatDate () {
                var date = new Date();
                var seperator = "-";
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = date.getFullYear() + seperator + month + seperator + strDate
                return currentdate
            }
        }
    }
</script>
